//
// Copyright 2022 DXOS.org
//

// TODO(burdon): Replace with Message component.
export const descriptionMessage = 'text-fg-muted border border-dashed border-separator rounded-sm p-4';
